export default {
    fees ( state ) {
        return state.fees;
    }
}